// src/components/MobileNavbar.tsx
import { createSignal } from "solid-js";
import { useLocation, A } from "@solidjs/router";
import { twMerge } from "tailwind-merge";
import { useColor } from "../lib/useColor";
import { sideMenuRoutes } from "../routes";
import usePermissions from "../lib/usePermissions";

const MobileNavbar = () => {
  const location = useLocation();
  const permissions = usePermissions();
  const [isOpen, setIsOpen] = createSignal(false);
  const [color] = useColor();
  const handleClickNav = () => setIsOpen(!isOpen());

  return (
    <div class="md:hidden">
      <div
        onClick={handleClickNav}
        class="fixed z-50 bottom-8 right-8 p-1.5 rounded-full backdrop-blur-md bg-[var(--color-primary)]"
      >
        <button class="flex-col items-center justify-center lg:flex">
          <span
            class={twMerge(
              "bg-[var(--color-primary)] transition-all duration-300 ease-out block h-0.5 w-6 rounded-sm",
              isOpen() ? "rotate-45 translate-y-1" : "-translate-y-0.5",
              ["color-yellow"].includes(color()) && "bg-gray-800",
              ["color-violet", "color-green", "color-blue"].includes(color()) &&
                "bg-white"
            )}
          />
          <span
            class={twMerge(
              "bg-[var(--color-primary)] transition-all duration-300 ease-out block h-0.5 w-6 rounded-sm my-0.5",
              isOpen() ? "opacity-0" : "opacity-100",
              ["color-yellow"].includes(color()) && "bg-gray-800",
              ["color-violet", "color-green", "color-blue"].includes(color()) &&
                "bg-white"
            )}
          />
          <span
            class={twMerge(
              "bg-[var(--color-primary)] transition-all duration-300 ease-out block h-0.5 w-6 rounded-sm",
              isOpen() ? "-rotate-45 -translate-y-1" : "translate-y-0.5",
              ["color-yellow"].includes(color()) && "bg-gray-800",
              ["color-violet", "color-green", "color-blue"].includes(color()) &&
                "bg-white"
            )}
          />
        </button>
      </div>

      {isOpen() && (
        <div class="min-w-[70vw] z-50 flex flex-col items-center justify-between fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-black/75 dark:bg-white/70 rounded-lg backdrop-blur-md py-32">
          <div class="flex flex-col items-center gap-4">
            {sideMenuRoutes.map((menu) => {
              if (
                typeof menu?.permission === "undefined" ||
                permissions()?.has(menu?.permission)
              ) {
                let isActive = location.pathname === menu.pathname;
                if (menu?.pathname !== "/")
                  isActive = location.pathname.indexOf(`${menu.pathname}`) > -1;

                return (
                  <nav>
                    <A
                      href={menu.pathname}
                      onClick={handleClickNav}
                      class={
                        isActive
                          ? "flex items-center text-white dark:text-black border-b-2 border-white dark:border-black text-sm font-semibold pb-0.5"
                          : "flex items-center text-sm text-white dark:text-black pb-0.5"
                      }
                    >
                      <div>{menu.name}</div>
                    </A>
                  </nav>
                );
              }
              return <></>;
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileNavbar;
